const DEFAULT_FRACTION_DIGITS = 2;

/**
 * Returns the number of fraction digits a currency uses according to ISO 4217
 * (e.g. 2 for EUR/USD, 0 for JPY/KRW/VND). Falls back to 2 when the currency is
 * missing or not recognised by the runtime.
 */
export function getCurrencyFractionDigits(currency) {
  if (!currency) return DEFAULT_FRACTION_DIGITS;
  try {
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency,
    }).resolvedOptions().maximumFractionDigits;
  } catch (e) {
    return DEFAULT_FRACTION_DIGITS;
  }
}

/**
 * Builds Intl/react-intl number format options that render the exact number of
 * fraction digits a currency uses, so zero-decimal currencies (e.g. JPY) are
 * displayed without trailing decimals.
 */
export function getCurrencyFractionDigitsOptions(currency) {
  const fractionDigits = getCurrencyFractionDigits(currency);
  return {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  };
}
